<div class="d-flex justify-content-center loader">
    <div role="status" class="spinner-border mx-auto">
        <span class="sr-only">Nalagam...</span>
        @if (!onlyIcon()) {
            <div class="sr-only">{{ text() }}</div>
        }
    </div>
</div>
